import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  fullWidth?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  href = 'https://barkvee.com/products/lissea',
  fullWidth = false,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.02,
    translateY: -2
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center gap-2 
        bg-brand-600 hover:bg-brand-700 text-white 
        font-sans font-bold text-lg md:text-xl
        py-4 px-8 rounded-xl shadow-lg shadow-brand-600/20
        transition-colors duration-200
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-13">
      {children}
      <ChevronRightIcon className="w-6 h-6" data-id="element-14" />
    </motion.a>;
}